<template>
  <div class="reports">
    <h1>Отчёты:</h1>
    <ProgressSpinner v-if="isLoading" />
    <ReportsTable
      :reports="reports"
      v-else-if="reports && reports.length > 0"
    />
    <p v-else>Список отчетов пуст</p>
  </div>
</template>

<script lang="ts">
import ReportsTable from "@/components/PersonalCabinet/ReportsTable.vue";
import ProgressSpinner from "primevue/progressspinner";

import { defineComponent, PropType } from "vue";
import { reportsModuleMapper } from "@/store/modules/reports";

export default defineComponent({
  name: "Reports",
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    ...reportsModuleMapper.mapGetters(["reports"]),
  },
  methods: {
    ...reportsModuleMapper.mapActions([
      "resetReports",
      "fetchReportsByCategory",
      "fetchAllReports",
    ]),
    async updateTable() {
      this.isLoading = true;
      this.resetReports();
      if (this.categoryId) await this.fetchReportsByCategory(this.categoryId);
      else await this.fetchAllReports();
      this.isLoading = false;
    },
  },
  async mounted() {
    await this.updateTable();
  },
  props: {
    categoryId: {
      type: Object as PropType<number | undefined>,
      required: false,
    },
    updateId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  watch: {
    async categoryId() {
      await this.updateTable();
    },
    async updateId() {
      await this.updateTable();
    },
  },
  components: {
    ReportsTable,
    ProgressSpinner,
  },
});
</script>

<style lang="scss" scoped>
h1,
p {
  margin: 50px 10px;
}
</style>
